import store from '../../store/store';

export default function Desc(opts={}){
    BaseConstructor.call(this)
    let {container,state} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div', 'desc-container font-weight-bold')
        // elements.title = this.createElement('div', 'item-title', state.title)
        // elements.item = this.createElement('div', 'item')
        $(container).append(elements.container)
    }

    this.updateContent = content =>{
        $(elements.container).html(content)
    }

    

    init()

    function init(){
        store.subscribe('SET_OPTION', data=>{
            if(data.option === 'current_active'){
                context.updateContent(data.value)
            }
        })
    }
}

Desc.prototype = Object.create(BaseConstructor.prototype)